import React from "react";
import { useNavigate } from "react-router-dom";
import { useUserPreferences } from "../contexts/UserPreferencesContext";
import { Sun, Moon, Globe } from "lucide-react";

const translations = {
  EN: {
    userPanel: "User Panel",
    adminPanel: "Admin Panel",
    welcome: "Welcome",
    signOut: "Sign out",
    signIn: "Sign in",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
  },
  PL: {
    userPanel: "Panel Użytkownika",
    adminPanel: "Panel Admina",
    welcome: "Witaj",
    signOut: "Wyloguj",
    signIn: "Zaloguj",
    darkMode: "Tryb Ciemny",
    lightMode: "Tryb Jasny",
  },
};

const NavigationHeader = ({ auth }) => {
  const navigate = useNavigate();
  const { theme, language, updateTheme, updateLanguage } = useUserPreferences();
  const groups = auth.user?.profile["cognito:groups"] || [];
  const isAdmin = groups.includes("Admins");
  const t = translations[language];

  const toggleTheme = () => {
    updateTheme(theme === "light" ? "dark" : "light");
  };

  const toggleLanguage = () => {
    updateLanguage(language === "EN" ? "PL" : "EN");
  };

  return (
    <div
      className={`${
        theme === "dark" ? "bg-gray-800 text-white" : "bg-gray-100"
      } p-4 mb-6 transition-colors duration-200`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex space-x-4 items-center">
          {auth.isAuthenticated && (
            <>
              <button
                onClick={() => navigate("/user-panel")}
                className={`px-3 py-2 rounded-md hover:bg-opacity-10 hover:bg-black transition-colors ${
                  theme === "dark"
                    ? "text-blue-300 hover:text-blue-200"
                    : "text-blue-600 hover:text-blue-800"
                }`}
              >
                {t.userPanel}
              </button>
              {isAdmin && (
                <button
                  onClick={() => navigate("/admin-panel")}
                  className={`px-3 py-2 rounded-md hover:bg-opacity-10 hover:bg-black transition-colors ${
                    theme === "dark"
                      ? "text-blue-300 hover:text-blue-200"
                      : "text-blue-600 hover:text-blue-800"
                  }`}
                >
                  {t.adminPanel}
                </button>
              )}
            </>
          )}
        </div>

        <div className="flex items-center space-x-4">
          <button
            onClick={toggleTheme}
            className="p-2 rounded-full hover:bg-opacity-10 hover:bg-black transition-colors"
            title={theme === "light" ? t.darkMode : t.lightMode}
          >
            {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
          </button>

          <button
            onClick={toggleLanguage}
            className="p-2 rounded-full hover:bg-opacity-10 hover:bg-black transition-colors flex items-center"
          >
            <Globe size={20} className="mr-1" />
            <span>{language}</span>
          </button>

          {auth.isAuthenticated ? (
            <>
              <span
                className={theme === "dark" ? "text-gray-300" : "text-gray-600"}
              >
                {t.welcome}, {auth.user?.profile["cognito:username"]}
              </span>
              <button
                onClick={() => auth.removeUser()}
                className={`px-3 py-2 rounded-md hover:bg-opacity-10 hover:bg-black transition-colors ${
                  theme === "dark"
                    ? "text-blue-300 hover:text-blue-200"
                    : "text-blue-600 hover:text-blue-800"
                }`}
              >
                {t.signOut}
              </button>
            </>
          ) : (
            <button
              onClick={() => auth.signinRedirect()}
              className={`px-3 py-2 rounded-md hover:bg-opacity-10 hover:bg-black transition-colors ${
                theme === "dark"
                  ? "text-blue-300 hover:text-blue-200"
                  : "text-blue-600 hover:text-blue-800"
              }`}
            >
              {t.signIn}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavigationHeader;
